/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_03_Detail_Tournament_0_HeadingInputs */

const en_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Static imagery bias`)
};

const es_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesgo de la imaginería estática`)
};

const de_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statische Bildvoreingenommenheit`)
};

const zh_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`静态图像偏差`)
};

const ar_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تحيز الصور الثابتة`)
};

const fr_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biais d’imagerie statique`)
};

const vi_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiên kiến hình ảnh tĩnh`)
};

const sw_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upendeleo wa picha tuli`)
};

const th_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อคติจากภาพนิ่ง`)
};

const bs_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pristrasnost statičnih slika`)
};

const ja_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`静止画によるバイアス`)
};

const ko_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정지 이미지 편향`)
};

const pt_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O viés da imagem estática`)
};

const it_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il bias dell'immagine statica`)
};

const sv_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bias från statiska bilder`)
};

const nl_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertekening door statische beelden`)
};

const da_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bias fra statiske billeder`)
};

const nb_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skjevhet fra statiske bilder`)
};

const fi_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pysäytyskuvan vinouma`)
};

const pl_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pułapka statycznego obrazu`)
};

const ru_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Искажение из-за статичных изображений`)
};

const tr_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statik görüntü yanlılığı`)
};

const hi_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिर तस्वीरों का पूर्वाग्रह`)
};

const id_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bias citra statis`)
};

const ms_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bias imej statik`)
};

const cs_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkreslení statickým obrazem`)
};

const el_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η προκατάληψη της στατικής εικόνας`)
};

const he_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הטיית התמונה הסטטית`)
};

const af_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statiese beeldvooroordeel`)
};

const hu_method_content_step_03_detail_tournament_0_heading = /** @type {(inputs: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az állóképek torzítása`)
};

/**
* | output |
* | --- |
* | "Static imagery bias" |
*
* @param {Method_Content_Step_03_Detail_Tournament_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_03_detail_tournament_0_heading = /** @type {((inputs?: Method_Content_Step_03_Detail_Tournament_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_03_Detail_Tournament_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "de") return de_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "th") return th_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "it") return it_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "da") return da_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "id") return id_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "el") return el_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "he") return he_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "af") return af_method_content_step_03_detail_tournament_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_03_detail_tournament_0_heading(inputs)
	return en_method_content_step_03_detail_tournament_0_heading(inputs)
});